import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import CardService from '../services/CardService';
class PinEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            pin: this.props.pin,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setState({
                pin: this.props.pin,
            });
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        const {pin} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .updatePin({pin, cards: this.props.cardNumbers})
                .then((response) => {
                    // this.blockUi();
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <InputTextComponent
                        id='pin-dialog'
                        name='pin'
                        label={t('cards.plasticCardPin')}
                        colClass='col-12'
                        value={this.state.pin}
                        viewMode={'EDIT'}
                        validator={this.validator}
                        validators={'required|pin|numeric|max:4|min:4'}
                        onChange={this.handleChange}
                        stateField={''}
                        keyfilter={/^[0-9]*$/i}
                        max={4}
                    />
                </div>
            </React.Fragment>
        );
    }
}

PinEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

PinEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
};

export default withTranslation()(PinEditDialog);
